var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-Pin';
                    var viewUrl = 'gfx/sprite.svg#view-icon-Pin';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 10 16',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };